import { useState, useRef, useEffect } from "react";
import { Modal, ModalBody, ModalFooter, Form, Button, Input } from "@gpstrackit/react-controls";
import { useSelector, useDispatch } from "react-redux";
//Language
import { useIntl } from "react-intl";

import { logoutAllSessions, reset } from './redux/slice';

//Notification
import {
    NotificationManager
} from "Components/Notifications";

//Styles
import "./logoutPrompt.scss";

const LogoutPrompt = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const formRef = useRef();

    //redux states
    const openModal = useSelector(state => state.logoutPromptRedux.openModal);
    const loading = useSelector(state => state.logoutPromptRedux.loadingLogoutPrompt);
    const result = useSelector(state => state.logoutPromptRedux.result);
    const error = useSelector(state => state.logoutPromptRedux.error);
    const user = useSelector(state => state.securityRedux.user);


    const closeModal = () => {
        props?.closeModal && props.closeModal();
        dispatch(reset())
    }

    useEffect(() => {
        if (result) {
            NotificationManager.success(messages['logout_prompt_changed'], messages['logout_prompt_title'], 3000, null, null, '', null);
            closeModal();
        }
        if (error) {
            if (error?.error) {
                try {
                    let message = error?.error.replace("NotAuthorizedException: ", "")
                    message = message.replace("LimitExceededException: ", "")
                    if (message.includes("Incorrect username")) {
                        message = messages['logout_prompt_incorrect']
                    }
                    if (message.includes("limit exceeded")) {
                        message = messages['logout_prompt_limit_exceeded']
                    }
                    NotificationManager.error(message, messages['logout_prompt_title'], 3000, null, null, '', null);
                } catch (error) { }
            }
            dispatch(reset({ error: null }));
        }
    }, [result, error]);

    return (
        <Modal
            open={openModal}
            loading={loading}
            title={messages['logout_prompt_title']}
            size="small"
            handleClose={() => { }}
        >
            <ModalBody>
                <Form
                    ref={formRef}
                    onValidSubmit={() => {
                        dispatch(logoutAllSessions({
                            id: user.userId
                        }))

                    }}
                >
                    <div className="change-password-container">
                        {
                            <p style={{ color: 'black', textAlign: 'center', fontSize: 12, marginTop: 10 }}>{messages['logout_prompt_message']}</p>
                        }
                    </div>
                </Form>
            </ModalBody>
            <ModalFooter>
                <div className="change-password-footer">
                    <Button
                        className="btn-dark-blue"
                        onClick={(e) => {
                            e.preventDefault();
                            formRef.current.submit()
                        }}
                    >
                        {messages['common_accept']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default LogoutPrompt;